<template>
  <v-navigation-drawer app temporary elevation="10" location="right" v-model="customizer.Customizer_drawer">
    <div class="px-4 py-4">
      <h3>개인설정</h3>
    </div>
    <v-divider></v-divider>

    <!-- <div class="px-4 py-4" v-if="!isDark">
      <h4 class="mb-3">Topbar Colors</h4>

      <v-item-group mandatory v-model="customizer.navbarColor">
        <v-item v-slot="{ isSelected, toggle }" v-for="color in navbarColors" :key="color" :value="color">
          <v-avatar :class="isSelected && 'v-sidebar_active'" :color="color"
            class="v-settings__item mr-2 cursor-pointer" size="25" @click="toggle" />
        </v-item>
      </v-item-group>
    </div>
    <v-divider></v-divider>
    <div class="px-4 py-4" v-if="!isDark">
      <h4 class="mb-3">Sidebar Colors</h4>

      <v-item-group mandatory v-model="customizer.SidebarColor">
        <v-item v-slot="{ isSelected, toggle }" v-for="color in sidebarColors" :key="color" :value="color">
          <v-avatar :class="isSelected && 'v-sidebar_active'" :color="color"
            class="v-settings__item mr-2 cursor-pointer" size="25" @click="toggle" />
        </v-item>
      </v-item-group>
    </div>
    <v-divider></v-divider> -->
    <div class="px-4 py-4">
      <!-- <h4>Horizontal Layout</h4>
      <div @click="reloadPage">
        <v-checkbox hide-details v-model="customizer.setHorizontalLayout" label="Horizontal"></v-checkbox>
      </div>
      <br /> -->
      <h4>다크 모드</h4>
      <v-checkbox hide-details v-model="isDark" label="다크"></v-checkbox><br />
      <div v-if="!customizer.setHorizontalLayout">
        <h4>미니 사이드바</h4>
        <v-checkbox hide-details v-model="adminMainStore.personalSetting.miniSideBar" label="미니" />
      </div>
      <h4>폰트 크기</h4>
      <div class="flex items-center gap-1">
        <v-slider v-model="adminMainStore.personalSetting.fontSize" min="10" max="20" :step="1" hide-details />
        <div>{{ adminMainStore.personalSetting.fontSize }}</div>
      </div>
    </div>
    <v-divider></v-divider>
  </v-navigation-drawer>
</template>
<script setup lang="ts">
import { useDark, useToggle } from "@vueuse/core";
import { useDYAdminMainStore } from "~/modules/nuxt3-module-admin-doyac/stores/main";
import { useCustomizerStore } from "~~/modules/nuxt3-module-admin-doyac/stores/customizer";

const adminMainStore = useDYAdminMainStore()

function reloadPage() {
  if (customizer.setHorizontalLayout) {
    window.location.reload();
  }
}
const customizer = useCustomizerStore();
const isDark = useDark()
const toggleDark = useToggle(isDark)

const navbarColors = ref([
  "#ffffff",
  "#1e88e5",
  "#21c1d6",
  "#fc4b6c",
  "#563dea",
  "#ff9800",
]);
const sidebarColors = ref([
  "white",
  "#212121",
  "#1e88e5",
  "#fc4b6c",
  "#563dea",
  "#ff9800",
]);
</script>
<style lang="scss">
.v-application .v-item-group .v-avatar--density-default {
  border: 1px solid rgb(0, 0, 0, 0.1) !important;
}

.v-application .v-item-group .v-sidebar_active {
  border: 2px solid black !important;
}
</style>
